require('./core/alert-manager.js');
require('./core/announcements.js');
require('./core/file.js');
require('./core/font-awesome.js');
require('./core/global.js');
require('./core/modal-global.js');
require('./core/search.js');
require('./core/sidebar.js');
require('./custom/jquery.html5-placeholder-shim.js');
require('./module/timetable/eventdetails.js');
require('./module/timetable/jquery.timetable.js');
require('./views/absences/accesscontrol.js');
require('./views/absences/index.js');
require('./views/absences/reporting.js');
require('./views/choices/index.js');
require('./views/choices/report.js');
require('./views/communications/index.js');
require('./views/eportfolio/assignments.js');
require('./views/eportfolio/groups.js');
require('./views/eportfolio/myexperiences.js');
require('./views/eportfolio/mypersonalfiles.js');
require('./views/eportfolio/studentdashboard.js');
require('./views/eportfolio/students-report.js');
require('./views/eportfolio/submissions-report.js');
require('./views/eportfolio/submissions.js');
require('./views/help/reportaconcernform.js');
require('./views/help/requestsupportappointment.js');
require('./views/home/index.js');
require('./views/importantdocuments/addedit.js');
require('./views/importantdocuments/modals.js');
require('./views/importantdocuments/report.js');
require('./views/outcomes/index.js');
require('./views/pages/addeditresource.js');
require('./views/pages/index.js');
require('./views/regents/index.js');
require('./views/reporting/studentevents.js');
require('./views/reporting/studentfeedback.js');
require('./views/resources/manager.js');
require('./views/session/login.js');
require('./views/timetable/categories.js');
require('./views/timetable/index.js');
require('./views/timetable/rollover.js');
